// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 887) return "static/chunks/887-10f39aee7bc045b0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6855 ? "47bf8baf" : chunkId) + "." + {"2424":"ce50fd1801ed1a63","3669":"d0ca6d2ebe82cc24","5273":"0ac9c9b799cf1803","6855":"29a90347e6ca7652"}[chunkId] + ".js";
};